import { TranslateService } from "@ngstack/translate";
import {
  MatSelect,
  MatTableDataSource,
  MatPaginator,
  MatDialog
} from "@angular/material";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IBranch } from "src/app/interfaces/branch";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { TeacherToLvlEntryComponent } from "../teacher-to-lvl-entry/teacher-to-lvl-entry.component";
import { FormGroup, FormBuilder } from "@angular/forms";
import { HttpHeaders } from "@angular/common/http";
import { TimesheetManagementComponent } from "../../../main/timesheet-management/timesheet-management.component";

@Component({
  selector: "app-staff-list",
  templateUrl: "./staff-list.component.html",
  styleUrls: ["./staff-list.component.css"]
})
export class StaffListComponent implements OnInit, OnDestroy {
  isOwner: boolean;
  teacherList: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>();
  branchList: IBranch[];
  companyList: ICompany[];
  companySelected: string;
  form: FormGroup;
  displayedColumns: string[] = [
    this.translate.get("label.fullname"),
    this.translate.get("label.nationalCode"),
    "function"
  ];
  pageSize: number;
  pageIndex: number;
  constructor(
    private fb: FormBuilder,
    private bidService: BIDService,
    private cidService: CIDService,
    private dialog: MatDialog,
    private translate: TranslateService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private contractService: ContractService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.companySelected = this.cidService.getCID();
    this.form = this.fb.group(
      {
        NationalCode: [null],
        FirstName: [null],
        LastName: [null]
      }
    );

  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.getBranchList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  getBranchList() {
    this.branchService.list(true).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    if (this.isOwner) {
      this.cidService.setCID(e.value);
      this.bidService.setBID("");
    }
    this.getBranchList();
  }

  setBid(e: MatSelect) {
    if (this.isOwner)
      this.bidService.setBID(e.value);
    //this.getTeacherList(null);
  }

  getTeacherList(form: any) {
    console.log(form);

    this.contractService.getListTeacherInBranch(form).subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {

    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.cidService.getCID()
      );


    this.contractService
      .list(null, event.pageIndex + 1, event.pageSize, headers)
      .subscribe(res => {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  assignlevelToTeacher(e) {
    this.dialog.open(TeacherToLvlEntryComponent, {
      height: '95%',
      data: e
    });

  }

  showTimeSheetForm(e: any) {
    this.dialog.open(TimesheetManagementComponent, {
      width: "95%",
      data: {
        staff: e,
        nationalCode: e.NationalCode,
        cid: this.cidService.getCID(),
        bid: this.bidService.getBID(),
        branchName: this.bidService.getBName()
      }
    });
  }

  ngOnDestroy(): void {
    if (this.isOwner) {
      this.bidService.setBID("");
    }
  }
}
